export default {
    infoData: {
        companyName: '',
        siteName: '',
        ledgerName: '',
        businessType: '',
        feeTaskType: '',
        noTaxAmount: '',
        amount: '',
        remark: '',
        taxAmount: '',
        supplierComfirmAmount: ''
    },
    tableDataItems: [
        {
            prop: 'feeName',
            label: '费用名称',
            type: 'normal'
        },
        {
            prop: 'supContractNo',
            label: '合同号',
            type: 'normal'
        },
        {
            prop: 'whName',
            label: '仓库名称',
            type: 'normal'
        },
        {
            prop: 'belongMonth',
            label: '业务所属月份',
            type: 'normal'
        },
        {
            prop: 'quantity',
            label: '数量',
            type: 'normal'
        },
        {
            prop: 'price',
            label: '单价',
            type: 'normal'
        },
        {
            prop: 'noTaxAmount',
            label: '不含税收入',
            type: 'normal'
        },
        {
            prop: 'taxRate',
            label: '税率',
            type: 'normal'
        },
        {
            prop: 'taxAmount',
            label: '税额',
            type: 'normal'
        },
        {
            prop: 'amount',
            label: '含税收入',
            type: 'normal'
        },
        {
            prop: 'supplierAmount',
            label: '确认费用金额',
            type: 'normal'
        },
        {
            prop: 'supplierMsg',
            label: '备注',
            type: 'normal'
        },
        {
            prop: 'replyMsg',
            label: '安得回复',
            type: 'normal'
        }
    ]

};
